import axios from 'axios';

const getMcKinseyMeeting = async (eplId, honorarium) => {
  const mcKinseyData = await axios({
    method: 'get',
    url: `${process.env.REACT_APP_CAPI_SERVICE_URL}/scheduleDetails?eplId=${eplId}`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  });

  if (!!mcKinseyData.data.pin) {
    const {
      templateName,
      pin,
      phoneNumbers
    } = mcKinseyData.data;
    const mcKinseyNames = {
      "[CN] mck_schedule_invite_wh": 'zh-Hant',
      "[ES] mck_schedule_invite_wh": 'es',
      "[RU] mck_schedule_invite_wh": 'ru',
      "[DE] mck_schedule_invite_wh": 'de',
      "[FR] mck_schedule_invite_wh": 'fr',
      "[IT] mck_schedule_invite_wh": 'it',
      "[KR] mck_schedule_invite_wh": 'ko',
      "[PT] mck_schedule_invite_wh": 'pt',
      "[EN] mck_schedule_invite_wh": 'en',
      "[PL] mck_schedule_invite_wh": 'pl',
      "[CN] mck_schedule_invite": 'zh-Hant',
      "[ES] mck_schedule_invite": 'es',
      "[RU] mck_schedule_invite": 'ru',
      "[DE] mck_schedule_invite": 'de',
      "[FR] mck_schedule_invite": 'fr',
      "[IT] mck_schedule_invite": 'it',
      "[KR] mck_schedule_invite": 'ko',
      "[PT] mck_schedule_invite": 'pt',
      "[EN] mck_schedule_invite": 'en',
      "[PL] mck_schedule_invite": 'pl',
      "[JP] mck_schedule_invite": 'ja'
    };
    const tollNumbers = {
      "[CN] mck_schedule_invite_wh": '通行費號碼',
      "[ES] mck_schedule_invite_wh": 'número de peaje',
      "[RU] mck_schedule_invite_wh": 'номер автодорожных сборов',
      "[DE] mck_schedule_invite_wh": 'gebührenpflich',
      "[FR] mck_schedule_invite_wh": 'numéro de péage',
      "[IT] mck_schedule_invite_wh": 'numero di pedaggio',
      "[KR] mck_schedule_invite_wh": '수신자 번호',
      "[PT] mck_schedule_invite_wh": 'número de pedágio',
      "[EN] mck_schedule_invite_wh": 'toll number',
      "[PL] mck_schedule_invite_wh": 'numer opłaty drogowej',
      "[CN] mck_schedule_invite": '通行費號碼',
      "[ES] mck_schedule_invite": 'número de peaje',
      "[RU] mck_schedule_invite": 'номер автодорожных сборов',
      "[DE] mck_schedule_invite": 'gebührenpflich',
      "[FR] mck_schedule_invite": 'numéro de péage',
      "[IT] mck_schedule_invite": 'numero di pedaggio',
      "[KR] mck_schedule_invite": '수신자 번호',
      "[PT] mck_schedule_invite": 'número de pedágio',
      "[EN] mck_schedule_invite": 'toll number',
      "[PL] mck_schedule_invite": 'numer opłaty drogowej',
      "[JP] mck_schedule_invite": '通行番号'
    };
    const templates = await axios({
      method: 'get',
      url: `/api/email-template/group/mck_schedule_invite`,
      headers: {
        'Content-Type': 'application/json',
        authorization: window.localStorage.getItem('ngStorage-accessToken')
      }
    });
    const currentTemplate = templates.data.filter(t => t.name === templateName)[0];

    const region = (name, code) => new Intl.DisplayNames([mcKinseyNames[name]], {
      type: "region"
    }).of(code);

    const result = {
      phoneNumbers,
      currentTemplate,
      expertMessage: currentTemplate.content.replace('PIN', pin).replace('DIALIN_NUMBERS', phoneNumbers.map(number => `${region(currentTemplate.name, number.country_code)} ${tollNumbers[currentTemplate.name]}: <a href="tel:${number.international_format},,${pin}#">1-Tap</a> ${number.international_format} </br>`).join('')),
      templates: templates.data.filter(d => !!honorarium ? d.name.includes('_wh') || d.name.includes('[JP]') : !d.name.includes('wh')).map(template => ({ ...template,
        content: template.content.replace('PIN', pin).replace('DIALIN_NUMBERS', phoneNumbers.map(number => `${region(template.name, number.country_code)} ${tollNumbers[template.name]}: <a href="tel:${number.international_format},,${pin}#">1-Tap</a> ${number.international_format} </br>`).join(''))
      }))
    };
    return result;
  }

  return null;
};

export default getMcKinseyMeeting;